export default function* globalSaga() {}
